/* eslint-disable no-empty-pattern */
const api = require('../../firebaseConfig.js');

const state = {
  characters: []
};
const actions = {
  setupCharacters({ dispatch }, userID) {
    api.ACTS_Characters
    .doc(userID)
    .get()
    .then((doc) => {
      if (!doc.exists) {
        dispatch('createCharacterList', userID);
      }
      dispatch('getCharacters', userID);
    })
    .catch((error) => {
      console.log('Error retrieiving character information ' + error);
    });
  },
  createCharacterList({}, userID) {
    api.ACTS_Characters
      .doc(userID)
      .set({})
      .catch((error) => {
        console.log('Error creating account ' + error);
      });
  },
  getCharacters({ state }, userID) {
    state.characters = [];
    api.ACTS_Characters
    .doc(userID)
    .collection('characters')
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        const character = doc.data();
        character.name = doc.id;
        state.characters.push(character);
      });
    });
  },
  saveCharacter({ dispatch }, payload) {
    dispatch('deleteCharacter', payload)
      .then(() => {
        dispatch('createCharacter', payload);
      })
      .then(() => {
        dispatch('getCharacters', payload.id);
      });
  },
  addCharacter({ dispatch }, payload) {
    dispatch('createCharacter', payload).then(() => {
      dispatch('getCharacters', payload.id);
    });
  },
  removeCharacter({ dispatch }, payload) {
    dispatch('deleteCharacter', payload).then(() => {
      dispatch('getCharacters', payload.id);
    });
  },
  deleteCharacter({}, payload) {
    api.ACTS_Characters
    .doc(payload.id)
    .collection('characters')
    .doc(payload.oldName)
    .delete()
    .catch(function(error) {
      console.log('Error deleting character ' + error);
    });
  },
  createCharacter({}, payload) {
    const character = payload.character;
    api.ACTS_Characters
    .doc(payload.id)
    .collection('characters')
    .doc(character.name)
    .set(character)
    .catch(function(error) {
      console.log('Error creating character ' + error);
    });
  }
};

export default {
  namespaced: true,
  state,
  actions
};
